import { seoArticles } from '@/mocks/seoArticles';

export default function SeoArticlesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-6 h-6 flex items-center justify-center rounded bg-primary-100/70">
              <i className="ri-article-line text-xs text-primary-600"></i>
            </div>
            <span className="text-xs font-semibold text-primary-700 uppercase tracking-wider">Latest Articles</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            VigorBuy Spreadsheet <span className="text-primary-500">Guides &amp; Insights</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            Expert-written guides covering everything about the VigorBuy spreadsheet — safety, shipping, product picks, seller verification, and more.
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {seoArticles.map((article) => (
            <a
              key={article.slug}
              href={`/article/${article.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer hover:bg-background-100/80 transition-all duration-300 flex flex-col"
            >
              {/* Image */}
              <div className="aspect-[16/9] overflow-hidden bg-background-200/40">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-[10px] font-semibold text-primary-700 bg-primary-100/70 px-2.5 py-1 rounded-full uppercase tracking-wider whitespace-nowrap">
                    {article.label}
                  </span>
                  <span className="text-[10px] text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/50">
                  <span className="text-[11px] text-foreground-400">{article.date}</span>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-500 whitespace-nowrap">
                    Read More <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}